/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */
    categories: {
        edit: 'ویرایش دسته‌بندی‌ها',
    },

    /* Module special vocabulary */
    media: {
        menu: {
            create: 'افزودن عکس',
        }
    },

    helps: {
        menu: {
            index: 'پشتیبانی',
            create: 'مقاله جدید',
            list: 'مقالات راهنما',
            'categories-create': 'ایجاد دسته‌بندی',
            'categories-list': 'دسته‌بندی‌ها',
        },
        table_titles: {
            id: 'شناسه',
            title: 'موضوع',
            slug: 'اسلاگ',
            order: 'ترتیب',
            description: 'توضیحات',
            tags: 'برچسب‌ها',
            category: {
                id: 'شناسه',
                title: 'نام دسته‌بندی',
                slug: 'اسلاگ',
                order: 'ترتیب',
                icon: 'آیکون',
                description: 'خلاصه',
                setting: 'ویرایش / حذف',
            },
            setting: 'ویرایش / حذف'
        },
        faq_about: 'پرسش‌های متداول درباره',
        header_title: 'راهنما و پشتیبانی',
        search_placeholder: 'کلیدواژه‌های خود را تایپ کنید...',
        search_hint: 'نیاز به کمک دارید؟',
        view: 'مشاهده',
        edit: 'ویرایش مقاله'
    }
}
